<template>
    <div class="w3-margin">   
        <h4 class="page-title">TELJESÍTŐI LISTA</h4>
        Találatok: {{orderedAndFilteredList.length}} db
        <div class="w3-right cursorpointer">
            <table class="w3-hide-small">
                <tr>
                    <td>
                        <input v-model="query.startdate" type="date" class="w3-input w3-border w3-light-grey">
                    </td>    
                    <td>
                        <input v-model="query.enddate" type="date" class="w3-input w3-border w3-light-grey">                    
                    </td>    
                    <td>                                                        
                        <div v-on:click="startQuery" class="w3-button w3-padding w3-blue w3-hover-blue">OK</div>                                
                    </td>                                
                </tr>
            </table>                        
        </div>         
        <table v-if="certifyList" class="w3-table-all w3-small">
            <tr class="">
                <td class="w3-large">
                    <font-awesome-icon icon="filter"></font-awesome-icon>                                                
                </td>
                <td>
                    <input class="w3-input w3-border" v-model="filter.name">
                </td>
                <td>
                    <input class="w3-input w3-border" v-model="filter.hikeName">
                </td>
                <td class="w3-hide-small">
                </td>
                <td class="w3-hide-small">
                </td>                  
                <td >
                </td>                  
                <td class="w3-hide-small">
                    <select v-model="filter.mod" class="w3-input w3-border">
                        <option value=""></option>                        
                        <option v-for="(item, index) in $appData.certModeName" :key="index" v-bind:value="item">{{item}}</option>
                    </select>
                </td>  
                <td>
                    <select v-model="filter.status" class="w3-input w3-border">
                        <option value=-1></option>                        
                        <option v-for="(item, index) in $appData.certStatus" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                    </select>
                </td>
                <td class="w3-hide-small">
                </td>
            </tr>                        

            <tr class="theme-1">
                <td class="">#</td>
                <td v-on:click="sortBy('userName')" class="cursorpointer">
                    Név
                    <font-awesome-icon v-if="sortKey=='userName' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='userName' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                                
                </td>
                <td v-on:click="sortBy('hikeName')" class="cursorpointer">
                    Útvonal
                    <font-awesome-icon v-if="sortKey=='hikeName' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='hikeName' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                                
                </td>
                <td class="w3-hide-small w3-center cursorpointer" v-on:click="sortBy('enddate')">
                    Dátum
                    <font-awesome-icon v-if="sortKey=='enddate' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='enddate' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                </td>
                <td v-on:click="sortBy('sumtime')" class="w3-center cursorpointer">
                    Idő
                    <font-awesome-icon v-if="sortKey=='sumtime' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='sumtime' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                </td>                  
                <td v-on:click="sortBy('avgSpeed')" class="w3-center cursorpointer w3-hide-small">
                    Sebesség
                    <font-awesome-icon v-if="sortKey=='avgSpeed' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='avgSpeed' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                </td>                  
                <td v-on:click="sortBy('mode')" class="w3-center w3-hide-small cursorpointer">
                    Mód
                    <font-awesome-icon v-if="sortKey=='mode' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='mode' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                </td>  
                <td v-on:click="sortBy('status')" class="w3-center cursorpointer">
                    Státusz
                    <font-awesome-icon v-if="sortKey=='status' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                    <font-awesome-icon v-if="sortKey=='status' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                </td>
                <td class="w3-center w3-hide-small">
                    Értékelés                               
                </td>
            </tr>                        
            <tr class="cursorpointer" v-for="(item, index) in orderedAndFilteredList" :key="index" v-on:click="showUserCertify(item)">
                <td>{{index+1}}.</td>
                <td>{{item.userName}}</td>
                <td>{{item.hikeName}}</td>
                <td class="w3-hide-small w3-center">{{item.enddate | filterDateFormat}}</td>
                <td class="w3-center"><span v-if="item.sumtime>0">{{item.sumtime | filterNumberToTime2}}</span></td>
                <td class="w3-hide-small w3-center"><span v-if="item.status==2 || item.status==4">{{item.avgSpeed | filterFloatRound}} km/h</span></td>                    
                <td class="w3-hide-small w3-center"><span v-if="item.status==2 || item.status==4">{{item.mode}}</span></td>                                        
                <td class="w3-center">
                    <font-awesome-icon class="w3-text-black" v-if="item.status==0" icon="angle-double-right"></font-awesome-icon>
                    <font-awesome-icon class="w3-text-blue" v-if="item.status==1" icon="history"></font-awesome-icon>
                    <font-awesome-icon class="w3-text-green" v-if="item.status==2" icon="check-circle"></font-awesome-icon>
                    <font-awesome-icon class="w3-text-red" v-if="item.status==3" icon="times-circle"></font-awesome-icon>
                    <span class="w3-hide-small">{{item.status | filterNumberToStatus}}</span>                    
                </td>
                <td class="w3-hide-small w3-center">
                    <span v-if="item.rating==0">-</span>
                    <span v-else>{{item.rating}}</span>
                </td>
            </tr>
        </table> 

        <div v-if="isShowCertTable" class="w3-margin-top">
            <div v-if="certify" class="w3-padding w3-center w3-border-top w3-border-left w3-border-right"> 
                <div class="uppercase">{{certify.userName}}</div>
                <div class="uppercase">{{certify.hikeName}}</div>
                <div class="w3-small">
                    <font-awesome-icon class="w3-text-black" v-if="certify.status==0" icon="angle-double-right"></font-awesome-icon>
                    <font-awesome-icon class="w3-text-blue" v-if="certify.status==1" icon="history"></font-awesome-icon>
                    <font-awesome-icon class="w3-text-green" v-if="certify.status==2" icon="check-circle"></font-awesome-icon>
                    <font-awesome-icon class="w3-text-red" v-if="certify.status==3" icon="times-circle"></font-awesome-icon>
                            {{certify.status | filterNumberToStatus}}
                </div>
            </div>    
            <table class="w3-table-all w3-small">
                <tr class="theme-1">
                    <td>#</td>
                    <td>Ellenőrző pont</td>
                    <td class="w3-center">Áthaladási idő</td>
                    <td class="w3-hide-small w3-center">Eltelt idő</td>                    
                    <td class="w3-hide-small w3-center">Megtett táv</td>
                    <td class="w3-hide-small w3-center">Átlagsebesség</td>

                </tr>                
                <tr class="" v-for="(item, index) in certTable" :key="index">
                    <td>{{index+1}}.</td>
                    <td>{{item.name}}</td>
                    <td class="w3-center">{{item.date | filterDateTimeFormat}}</td>
                    <td class="w3-hide-small w3-center">{{item.time | filterNumberToTime2}}</td>                    
                    <td class="w3-hide-small w3-center">{{item.dist | filterNumberToDist}}</td>
                    <td class="w3-hide-small w3-center">{{item.avgSpeed | filterAvgSpeed}}</td>
                </tr>
            </table>
            <div v-on:click="closeCertTable" class="w3-small cursorpointer w3-right-align w3-margin-top w3-text-blue">[Teljesítési adatlap bezárása]</div>                                    
        </div>
    </div>

</template>

<script>

import "../filters.js";
const fb = require('../firebase.js');
export default {
    name: 'CertifyList',   
    data() {
        return {
            isShowCertTable:false,
            certTable:null,
            aktPoints:null,
            hikes:null,
            sortKey: 'enddate',
            reverse: 'desc',
            search: '',
            certifyList: [],
            imgData:null,
            filter:{
                "name":"",
                "hikeName":"",
                "dist":"",
                "mod":"",
                "status":-1
            },
            query:{
                startdate:null,
                enddate:null,
            }
        }
    }, 
    computed: {
        orderedAndFilteredList: function () {
            var orderedList=_.orderBy(this.certifyList, [this.sortKey], [this.reverse]);            
            var filteredList = orderedList.filter((item) => {
                const nameFilter = (item.userName.toLowerCase().indexOf(this.filter.name.toLowerCase())>-1);
                const hikeNameFilter = (item.hikeName.toLowerCase().indexOf(this.filter.hikeName.toLowerCase())>-1);                
                const modFilter = (item.mode==this.filter.mod && item.status==2) || (this.filter.mod=="");
                const statusFilter = (item.status==this.filter.status) || (this.filter.status==-1);
                return nameFilter && hikeNameFilter && modFilter &&statusFilter;
            });
            return filteredList;
        }
    },
    methods:{ 
        closeCertTable(){
            this.isShowCertTable=false;
            this.filter.name='';
            this.filter.hikeName='';
        },
        addSubSum(plist){
            var sumDist=0;
            var sumLevel=0;
            for (var i in plist){
                sumDist+=plist[i].prevDist;
                sumLevel+=plist[i].prevLevel;
                plist[i].sumDist=sumDist;
                plist[i].sumLevel=sumLevel;
            }
            return plist;
        }, 
        sortPointList(points,type) {
            var orderedList=points.sort((a,b) => (a.ordernum > b.ordernum) ? 1 : ((b.ordernum > a.ordernum) ? -1 : 0));            
            if (type==1) {
                var lastRow = Object.assign({}, orderedList[0]);
                orderedList.push(lastRow);
                orderedList[0].prevDist=0;
                orderedList[0].prevLevel=0;
            }
            return this.addSubSum(orderedList);
        },         
        sortBy(sortKey) {
            if (this.sortKey == sortKey) {
                if (this.reverse=='asc') this.reverse='desc';
                else this.reverse='asc';
            };
            this.sortKey = sortKey;
        },
        showUserCertify(item){
            fb.GetPoints2(item.hikeId).then(r=>{
                var avgSpeed=0; 
                if (item.sumtime>0) avgSpeed=item.distance/(item.sumtime/3600);

                var plist=[];
                for (var i in r) {
                    plist.push(r[i]);
                }                
                this.aktPoints=this.sortPointList(plist,item.type);
                fb.GetUserCertify(item.id,this.aktPoints).then(res=>{
                    this.certTable=res[0];
                    var l=this.certTable.length;
                    if (item.status>1) {
                        this.certTable[l-1].avgSpeed=item.avgSpeed;
                        this.certTable[l-1].time=item.sumtime;
                        this.certTable[l-1].date=item.enddate;
                    } else {
                        this.certTable[l-1].avgSpeed=null;
                        this.certTable[l-1].time=null;
                        this.certTable[l-1].date=null;
                        this.certTable[l-1].dist=null;
                    }
                    this.certify=res[1];
                    this.isShowCertTable=true;
                    this.filter.name=res[1].userName;
                    this.filter.hikeName=res[1].hikeName;
                })
                .catch(e=>{
                    console.log(e);
                });	       
            }).catch(e=>{
                console.log(e);
            }); 
        },
        formatDate(d){
            var month = '' + (d.getMonth() + 1);
            var day = '' + d.getDate();
            var year = d.getFullYear();
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
            return [year, month, day].join('-');
        },
        startQuery(){
            var date1=new Date(this.query.startdate).getTime(); 
            var date2=new Date(this.query.enddate).getTime()+86400000; 
            if (date1<date2) {
                this.$showSpinner();
                fb.GetCertifyByDate(date1,date2).then(res=>{
                    var allCertify=[];
                    for(var i in res) {
                        var c=res[i];
                        var avgSpeed=0; 
                        if (c.sumtime>0) avgSpeed=c.distance/(c.sumtime/3600);
                        c.avgSpeed=avgSpeed;
                        if (c) allCertify.push(c);
                    }
                    this.certifyList=allCertify;
                    this.$hideSpinner();
                }).catch(e=>{
                    console.log(e);
                    if (e.toString()=='Error: Network Error') {
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Ez a funkció offline állapotban nem érhető el.'));         
                    } else {
                        console.log(e);
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a lista betöltése során.'));         
                    }
                });
            } else {
                this.startQueryByStatus(0);
            }
        },
        startQueryByStatus(s){
            this.$showSpinner();
            fb.GetCertifyByStatus(s).then(res=>{
                var allCertify=[];
                for(var i in res) {
                    var c=res[i];
                    c.avgSpeed='';
                    if (c) allCertify.push(c);
                }
                this.certifyList=allCertify;
                this.$hideSpinner();
            }).catch(e=>{
                console.log(e);
                if (e.toString()=='Error: Network Error') {
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Ez a funkció offline állapotban nem érhető el.'));         
                } else {
                    console.log(e);
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a lista betöltése során.'));         
                }
            });
        },
        startQueryByRouteId(rid){
            this.$showSpinner();
            fb.GetCertifyByRouteId(rid).then(res=>{
                var allCertify=[];
                for(var i in res) {
                    var c=res[i];
                    var avgSpeed=0; 
                    if (c.sumtime>0) avgSpeed=c.distance/(c.sumtime/3600);
                    c.avgSpeed=avgSpeed;
                    if (c) allCertify.push(c);
                }
                this.certifyList=allCertify;
                this.$hideSpinner();
            }).catch(e=>{
                console.log(e);
                if (e.toString()=='Error: Network Error') {
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Ez a funkció offline állapotban nem érhető el.'));         
                } else {
                    console.log(e);
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a lista betöltése során.'));         
                }
            });
        }                           
    },
    mounted() { 
        if (this.$route.params.routeId) {
            this.startQueryByRouteId(this.$route.params.routeId);
        } else {   
            this.startQuery();
        }
    },
    created: function(){
        var d = new Date();
        this.query.enddate=this.formatDate(d);
        d.setDate(d.getDate()-365);
        this.query.startdate=this.formatDate(d);        
    }                 
}
</script>